import React from 'react'
import ControlGroup from '@pc/components/Works/Panel/shared/ControlGroup'
import CheckBoxGroup from '@pc/components/Works/Panel/shared/checkbox/CheckBoxGroup'
import CheckBoxInput from '@pc/components/Works/Panel/shared/checkbox/CheckBoxInput'
import CheckBoxLabel from '@pc/components/Works/Panel/shared/checkbox/CheckBoxLabel'
import CheckBoxFeatureInputSet from './CheckBoxFeatureInputSet'
import type { Feature } from '@pc/components/Works/Panel/type'

interface PropsType {
  features: Feature[]
  selectedFeatureIds: string[]
  changeState: (arg: any) => void
}

const FeatureItem = (props: PropsType) => {
  const { features, selectedFeatureIds, changeState } = props

  const toggleCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target

    if (checked) {
      const concatedFeatureIds = selectedFeatureIds.concat(value)
      changeState({ selectedFeatureIds: concatedFeatureIds })
    } else {
      const filteredFeatureIds = selectedFeatureIds.filter((selectedFeatureId) => selectedFeatureId !== value)
      changeState({ selectedFeatureIds: filteredFeatureIds })
    }
  }

  const featuresCheckboxes = features.map((feature) => {
    const { id, name } = feature.attributes
    const featureKey = `feature-${id}`
    return (
      <CheckBoxFeatureInputSet key={featureKey}>
        <CheckBoxInput type="checkbox" id={featureKey} value={id} onChange={toggleCheckbox} checked={selectedFeatureIds.includes(String(id))} />
        <CheckBoxLabel htmlFor={featureKey}>{name}</CheckBoxLabel>
      </CheckBoxFeatureInputSet>
    )
  })

  return (
    <ControlGroup>
      <CheckBoxGroup>{featuresCheckboxes}</CheckBoxGroup>
    </ControlGroup>
  )
}

export default FeatureItem
